import styled from 'styled-components';
import { Eye } from 'theme/icons';
import { CTAIconStyle } from '../common/style';
var PreviewIcon = styled(Eye).withConfig({
  displayName: "PreviewButtonstyle__PreviewIcon",
  componentId: "sc-7e7nu2-0"
})(["", ""], CTAIconStyle);
export { PreviewIcon };